/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */

import React from 'react';
import { Box, BoxProps } from 'chakra-v3';

interface ChatBubbleProps {
  children: React.ReactNode;
  innerPadding?: BoxProps['p'];
  containerProps?: BoxProps;
}

/**
 * ChatBubble Component
 *
 * Reusable component that provides the gradient border styling used across
 * User and Platform components. Creates a gradient border effect with an inner
 * content area.
 *
 * @param children - Content to render inside the bubble
 * @param innerPadding - Padding for the inner content area (default: "24px")
 * @param containerProps - Props to pass to the container Box (width, alignment, etc.)
 */
export const ChatBubble: React.FC<ChatBubbleProps> = ({ children, innerPadding = '24px', containerProps }) => {
  return (
    <Box backgroundImage="border.darkStroke" borderRadius="4px" p="1px" display="inline-block" {...containerProps}>
      <Box bg="brand.teal" borderRadius="3px" p={innerPadding}>
        {children}
      </Box>
    </Box>
  );
};
